(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icon-with-text-custom"] && !Shopify.designMode) return;
  try {
    function getVariantsData(variantSelects) {
    const jsonScript = variantSelects.querySelector('script[type="application/json"]');
    if (!jsonScript) return null;
    try {
      return JSON.parse(jsonScript.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariantId(variantSelects) {
    const variants = getVariantsData(variantSelects);
    if (!variants) return null;

    const selectedOptions = [];
    variantSelects.querySelectorAll('fieldset, select').forEach(function (group) {
      if (group.tagName === 'SELECT') {
        selectedOptions.push(group.value);
      } else {
        const checked = group.querySelector('input:checked');
        if (checked) selectedOptions.push(checked.value);
      }
    });

    const variant = variants.find(function (v) {
      return JSON.stringify(v.options) === JSON.stringify(selectedOptions);
    });
    return variant ? variant.id : null;
  }

  function getSelectedPrice(variantId) {
    const widget = document.getElementById('subscription-widget-' + variantId);
    if (!widget) return null;

    const checkedRadio = widget.querySelector('input[type="radio"]:checked');
    if (!checkedRadio) return null;

    const priceAttr = checkedRadio.getAttribute('data-selling-price');
    if (!priceAttr) return null;

    const cleaned = priceAttr.replace(/[^0-9.]/g, '');
    const price = parseFloat(cleaned);
    return isNaN(price) ? null : price;
  }

  function updateLoyaltyMessage() {
    const message = document.getElementById('c-loyalty-points-message');
    const variantSelects = document.querySelector('variant-selects');
    if (!message || !variantSelects) return;

    const variantId = getSelectedVariantId(variantSelects);
    if (!variantId) return;

    const price = getSelectedPrice(variantId);
    if (price === null) return;

    const points = Math.floor(price);

    if (window.customerLoggedIn) {
      message.innerHTML = `Earn <span class="c-loyalty-points">${points}</span> loyalty points with this purchase!`;
    } else {
      message.innerHTML = `<a href="${window.loginUrl}">Log in</a> or <a href="${window.registerUrl}">sign up</a> to earn <span class="c-loyalty-points">${points}</span> points!`;
    }
  }

  document.addEventListener('change', function (event) {
    const target = event.target;
    const isVariantChange = target.closest('variant-selects');
    const isPurchaseOptionChange = target.name && target.name.indexOf('purchaseOption_') === 0;

    if (isVariantChange || isPurchaseOptionChange) {
      updateLoyaltyMessage();
    }
  });

  updateLoyaltyMessage();
  } catch(e) { console.error(e); }
})();

})();
